import { techDataColsAPINames } from "../../configs/TechnicalDataEnums";
import { energyEfficiencyClassConf } from "../../functions/AssetOverview";
import { dynamicDashboardRelevantConfigOptions, getColumnDisplayName } from "../../utils/dynamicDashboard";
import { resolveCssVar } from "../../utils/styling";
import { chartTypesEnums, colorCategoriesEnums } from "../dynamicDashboard";
import {
  columnsDisplayNamesEnums as FinancialDashboardColumnsAPIDisplayNamesEnums,
  columnsAPINamesEnums as FinancialDashboardColumnsAPINamesEnums,
  retrofitsScaleableColumns,
} from "../Modernization/financialDashboard";
import {
  getTechDataPrefix,
  TechnicalDataColsDisplayNamesEnums,
  TechnicalDataColsNamesEnums,
} from "./portfolioTechnicalDataPart";

export const getPortfolioColumnDisplayName = ({ colName }) => {
  return getColumnDisplayName({ colName, dataMapping });
};

export const FiltersNames = Object.freeze({
  ADDRESS: "Addresse",
  AGGREGATION_TYPE: "aggregationType",
  CASH_IN: "cash_in",
  CO2_EMISSION: "CO2 Emissions",
  CONSTRUCTION_YEAR: "Construction year",
  COUNT: "Count",
  DATAPOINT: "dataPoint",
  DIAGRAMS: "diagrams",
  DIAGRAMS_COLOR: "color",
  DIAGRAMS_DIAGRAM_DATA_KEY: "dataKey",
  DIAGRAMS_DIAGRAM_TYPE: "diagramType",
  DIAGRAMS_DIRECTION: "direction",
  DIAGRAMS_PARTITIONS: "partitions",
  DIAGRAMS_STACKS: "stacks",
  ELECTRICITY_CONSUMPTION: "Electrictiy consumption",
  ENERGY_CONSUMPTION: "Energy consumption",
  ENERGY_EFFICIENCY_CLASS: "Energy Efficiency class",
  FLOOR_AMOUMT: "Floor amount",
  FOOTPRINT_AREA: "Footprint area",
  GROSS_AREA: "Gross area",
  GROSS_ASSET_VALUE: "gross_asset_value",
  HEAT_ENERGY_CONSUMPTION: "Heat energy consumption",
  HEAT_ENERGY_TYPE: "Heat energy type",
  ID: "ID",
  INVERT_X_AXIS: "invertXAxis",
  INVERT_Y_AXIS: "invertYAxis",
  LATITUDE: "lat",
  LEGEND_POSITION: "legendsPosition",
  LONGITUDE: "lon",
  MAIN_USAGE: "Main usage",
  NAME: "Name",
  PORTFOLIO: "Portfolio",
  PREMISE_AREA: "Premise area",
  SCALING_TYPE: "scalingType",
  SHOW_PIE_LABELS: "showPieLabels",
  SORT_VALUE: "sortValue",
  STRANDING_YEAR: "Stranding year",
  TITLE: "title",
  X_AXIS: "xAxis",
  X_AXIS_NAME: "xAxisName",
  Y_AXIS: "yAxis",
  Y_AXIS_NAME: "yAxisName",
});

const FinancialDataColsDisplayNamesEnums = Object.freeze({
  FINANCIAL_DATA__CASH_FLOW: "Cash Flow",
  FINANCIAL_DATA__ENERGY_SAVINGS: "Energy Savings",
  FINANCIAL_DATA__FOREIGN_CAPITAL: "Foreign Capital",
  FINANCIAL_DATA__FOREIGN_CAPITAL_COST: "Foreign Capital Cost",
  FINANCIAL_DATA__LOAN_REPAYMENT: "Loan Repayment",
  FINANCIAL_DATA__MAINTENANCE_COST: "Maintenance Costs",
  FINANCIAL_DATA__OTHER_SAVINGS: "Other Savings",
  FINANCIAL_DATA__OWN_CAPITAL: "Own Capital",
  FINANCIAL_DATA__SERVICES_COSTS: "Services Costs",
  FINANCIAL_DATA__SUBSIDIES: "Subsidies",
  FINANCIAL_DATA__TOTALS__ALL: "Agg: Sum of Financial Data Points",
  FINANCIAL_DATA__YEAR: "Year",
});

const FINANCIAL_DATA_KEYS_PREFIX = "FINANCIAL_DATA__";
export const getFinancialDataPrefix = (key) => {
  return FINANCIAL_DATA_KEYS_PREFIX + key;
};
export const FinancialDataColsNamesEnums = Object.freeze({
  FINANCIAL_DATA__CASH_FLOW: getFinancialDataPrefix("cashFlow"),
  FINANCIAL_DATA__ENERGY_SAVINGS: getFinancialDataPrefix("energySavings"),
  FINANCIAL_DATA__FOREIGN_CAPITAL: getFinancialDataPrefix("foreignCapital"),
  FINANCIAL_DATA__FOREIGN_CAPITAL_COST: getFinancialDataPrefix("foreignCapitalCost"),
  FINANCIAL_DATA__LOAN_REPAYMENT: getFinancialDataPrefix("loanRepayment"),
  FINANCIAL_DATA__MAINTENANCE_COST: getFinancialDataPrefix("maintenanceCosts"),
  FINANCIAL_DATA__OTHER_SAVINGS: getFinancialDataPrefix("otherSavings"),
  FINANCIAL_DATA__OWN_CAPITAL: getFinancialDataPrefix("ownCapital"),
  FINANCIAL_DATA__SERVICES_COSTS: getFinancialDataPrefix("servicesCosts"),
  FINANCIAL_DATA__SUBSIDIES: getFinancialDataPrefix("subsidies"),
  FINANCIAL_DATA__TOTALS__ALL: "FINANCIAL_DATA__TOTALS__ALL",
  FINANCIAL_DATA__YEAR: getFinancialDataPrefix("year"),
});

const RETROFITS_KEYS_PREFIX = "RETROFITS__";
export const getRetrofitPrefix = (key) => {
  return RETROFITS_KEYS_PREFIX + key;
};

export const RetrifitsColsNamesEnums = Object.freeze({
  RETROFITS__ADAPTATION: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.ADAPTATION),
  RETROFITS__CARBON_DIOXIDE_SAVINGS: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.CARBON_DIOXIDE_SAVINGS),
  RETROFITS__COMPONENT: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.COMPONENT),
  RETROFITS__COST_SAVINGS: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.COST_SAVINGS),
  RETROFITS__ELECTRICITY_COST_SAVINGS: getRetrofitPrefix(
    FinancialDashboardColumnsAPINamesEnums.ELECTRICITY_COST_SAVINGS
  ),
  RETROFITS__ELECTRICITY_REDUCTION: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.ELECTRICITY_REDUCTION),
  RETROFITS__EMBODIED_CARBON: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.EMBODIED_CARBON),
  RETROFITS__FOEIGN_CAPITAL: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.FOEIGN_CAPITAL),
  RETROFITS__HEAT_ENERGY_COST_SAVINGS: getRetrofitPrefix(
    FinancialDashboardColumnsAPINamesEnums.HEAT_ENERGY_COST_SAVINGS
  ),
  RETROFITS__HEAT_REDUCTION: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.HEAT_REDUCTION),
  RETROFITS__ID: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.ID),
  RETROFITS__INFLATION_RATE: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.INFLATION_RATE),
  RETROFITS__INTEREST_RATE: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.INTEREST_RATE),
  RETROFITS__INVESTMENTS: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.INVESTMENTS),
  RETROFITS__LOAN_TYPE: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.LOAN_TYPE),
  RETROFITS__MAINTENANCE_COST: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.MAINTENANCE_COST),
  RETROFITS__MEASURE_DESCRIPTION: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.MEASURE_DESCRIPTION),
  RETROFITS__NAME: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.NAME),
  RETROFITS__OTHER_COST_SAVINGS: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.OTHER_COST_SAVINGS),
  RETROFITS__OWN_CAPITAL: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.OWN_CAPITAL),
  RETROFITS__PDF_URL: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.PDF_URL),
  RETROFITS__REDUCTION_ELECTRICITY_END: getRetrofitPrefix(
    FinancialDashboardColumnsAPINamesEnums.REDUCTION_ELECTRICITY_END
  ),
  RETROFITS__REDUCTION_ELECTRICITY_PRIMARY: getRetrofitPrefix(
    FinancialDashboardColumnsAPINamesEnums.REDUCTION_ELECTRICITY_PRIMARY
  ),
  RETROFITS__REDUCTION_ENERGY_DEMAND: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.REDUCTION_ENERGY_DEMAND),
  RETROFITS__REDUCTION_ENERGY_END: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.REDUCTION_ENERGY_END),
  RETROFITS__REDUCTION_ENERGY_PRIMARY: getRetrofitPrefix(
    FinancialDashboardColumnsAPINamesEnums.REDUCTION_ENERGY_PRIMARY
  ),
  RETROFITS__REDUCTION_HEAT_END: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.REDUCTION_HEAT_END),
  RETROFITS__REDUCTION_HEAT_PRIMARY: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.REDUCTION_HEAT_PRIMARY),
  RETROFITS__REPAYMENT_TIME: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.REPAYMENT_TIME),
  RETROFITS__ROI: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.ROI),
  RETROFITS__SERVICES_COST: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.SERVICES_COST),
  RETROFITS__SUB_COMPONENT: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.SUB_COMPONENT),
  RETROFITS__SUBSIDIES: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.SUBSIDIES),
  RETROFITS__TOTAL_COST: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.TOTAL_COST),
  RETROFITS__TOTAL_ENERGY_REDUCTION: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.TOTAL_ENERGY_REDUCTION),
  // RETROFITS__TOTALS__REDUCTIONS: "RETROFITS__TOTALS__REDUCTIONS", Can be added when needed
  RETROFITS__TYPE_OF_MESSURE: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.TYPE_OF_MESSURE),
  RETROFITS__YEAR: getRetrofitPrefix(FinancialDashboardColumnsAPINamesEnums.YEAR),
});

export const RetrifitsColsDisplayNamesEnums = Object.freeze({
  RETROFITS__ADAPTATION: FinancialDashboardColumnsAPIDisplayNamesEnums.ADAPTATION,
  RETROFITS__CARBON_DIOXIDE_SAVINGS: FinancialDashboardColumnsAPIDisplayNamesEnums.CARBON_DIOXIDE_SAVINGS,
  RETROFITS__COMPONENT: FinancialDashboardColumnsAPIDisplayNamesEnums.COMPONENT,
  RETROFITS__COST_SAVINGS: FinancialDashboardColumnsAPIDisplayNamesEnums.COST_SAVINGS,
  RETROFITS__ELECTRICITY_COST_SAVINGS: FinancialDashboardColumnsAPIDisplayNamesEnums.ELECTRICITY_COST_SAVINGS,
  RETROFITS__ELECTRICITY_REDUCTION: FinancialDashboardColumnsAPIDisplayNamesEnums.ELECTRICITY_REDUCTION,
  RETROFITS__EMBODIED_CARBON: FinancialDashboardColumnsAPIDisplayNamesEnums.EMBODIED_CARBON,
  RETROFITS__FOEIGN_CAPITAL: FinancialDashboardColumnsAPIDisplayNamesEnums.FOEIGN_CAPITAL,
  RETROFITS__HEAT_ENERGY_COST_SAVINGS: FinancialDashboardColumnsAPIDisplayNamesEnums.HEAT_ENERGY_COST_SAVINGS,
  RETROFITS__HEAT_REDUCTION: FinancialDashboardColumnsAPIDisplayNamesEnums.HEAT_REDUCTION,
  RETROFITS__ID: FinancialDashboardColumnsAPIDisplayNamesEnums.ID,
  RETROFITS__INFLATION_RATE: FinancialDashboardColumnsAPIDisplayNamesEnums.INFLATION_RATE,
  RETROFITS__INTEREST_RATE: FinancialDashboardColumnsAPIDisplayNamesEnums.INTEREST_RATE,
  RETROFITS__INVESTMENTS: FinancialDashboardColumnsAPIDisplayNamesEnums.INVESTMENTS,
  RETROFITS__LOAN_TYPE: FinancialDashboardColumnsAPIDisplayNamesEnums.LOAN_TYPE,
  RETROFITS__MAINTENANCE_COST: FinancialDashboardColumnsAPIDisplayNamesEnums.MAINTENANCE_COST,
  RETROFITS__MEASURE_DESCRIPTION: FinancialDashboardColumnsAPIDisplayNamesEnums.MEASURE_DESCRIPTION,
  RETROFITS__NAME: FinancialDashboardColumnsAPIDisplayNamesEnums.NAME,
  RETROFITS__OTHER_COST_SAVINGS: FinancialDashboardColumnsAPIDisplayNamesEnums.OTHER_COST_SAVINGS,
  RETROFITS__OWN_CAPITAL: FinancialDashboardColumnsAPIDisplayNamesEnums.OWN_CAPITAL,
  RETROFITS__PDF_URL: FinancialDashboardColumnsAPIDisplayNamesEnums.PDF_URL,
  RETROFITS__REDUCTION_ELECTRICITY_END: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_ELECTRICITY_END,
  RETROFITS__REDUCTION_ELECTRICITY_PRIMARY: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_ELECTRICITY_PRIMARY,
  RETROFITS__REDUCTION_ENERGY_DEMAND: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_ENERGY_DEMAND,
  RETROFITS__REDUCTION_ENERGY_END: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_ENERGY_END,
  RETROFITS__REDUCTION_ENERGY_PRIMARY: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_ENERGY_PRIMARY,
  RETROFITS__REDUCTION_HEAT_END: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_HEAT_END,
  RETROFITS__REDUCTION_HEAT_PRIMARY: FinancialDashboardColumnsAPIDisplayNamesEnums.REDUCTION_HEAT_PRIMARY,
  RETROFITS__REPAYMENT_TIME: FinancialDashboardColumnsAPIDisplayNamesEnums.REPAYMENT_TIME,
  RETROFITS__ROI: FinancialDashboardColumnsAPIDisplayNamesEnums.ROI,
  RETROFITS__SERVICES_COST: FinancialDashboardColumnsAPIDisplayNamesEnums.SERVICES_COST,
  RETROFITS__SUB_COMPONENT: FinancialDashboardColumnsAPIDisplayNamesEnums.SUB_COMPONENT,
  RETROFITS__SUBSIDIES: FinancialDashboardColumnsAPIDisplayNamesEnums.SUBSIDIES,
  RETROFITS__TOTAL_COST: FinancialDashboardColumnsAPIDisplayNamesEnums.TOTAL_COST,
  RETROFITS__TOTAL_ENERGY_REDUCTION: FinancialDashboardColumnsAPIDisplayNamesEnums.TOTAL_ENERGY_REDUCTION,
  // RETROFITS__TOTALS__REDUCTIONS: "Agg: Sum of Retrofits Reductions", // Can be added when needed
  RETROFITS__TYPE_OF_MESSURE: FinancialDashboardColumnsAPIDisplayNamesEnums.TYPE_OF_MESSURE,
  RETROFITS__YEAR: FinancialDashboardColumnsAPIDisplayNamesEnums.YEAR,
});

const groupedColsNamesEnums = Object.freeze({
  // GROUPED__CONSUMPTION: "GROUPED__consumption",  // Can be added when needed
  GROUPED__FINANCIAL_DATA__ALL: "GROUPED__FINANCIAL_DATA__all",
  // GROUPED__RETROFITS__REDUCTIONS: "GROUPED__RETROFITS__reductions", // Can be added when needed
});

const groupedColsDisplayNamesEnums = Object.freeze({
  // GROUPED__CONSUMPTION: "Consumptions Group", // Can be added when needed
  GROUPED__FINANCIAL_DATA__ALL: "Financial Data Points Group",
  // GROUPED__RETROFITS__REDUCTIONS: "Retrofits Reductions Group", // Can be added when needed
});

export const columnsDisplayNamesEnums = Object.freeze({
  BALCONY: "Balkone",
  BOUGHT_ON: "Bought on",
  BUILDING_ID: "Building ID",
  BUILDING_NAME: "Building Name",
  BUILDING_TYPE: "Building Type",
  BUILDING_TYPE_ID: "Building Type ID",
  CEILING_AREA: "Ceiling Area",
  CITY: "City",
  CO2_EMISSION: "CO2 Emissions",
  COUNT: "Count",
  DIFFUSE_SOLAR_PER_M2: "Diffuse Solar (per m2)",
  DIFFUSE_SOLAR_TOTAL: "Diffuse Solar Total",
  DIRECT_SOLAR_PER_M2: "Direct Solar (per m2)",
  DIRECT_SOLAR_TOTAL: "Direct Solar Total",
  DISTRICT_HEATING_AVAILABLE: "District Heating available",
  ELECTRICITY_DEMAND_KWH_A: "Electricity Demand kWh/a",
  ELECTRICITY_DEMAND_KWH_M2A: "Electricity Demand kWh/m²/a",
  ENERGY_CONSUMPTION_RATIO: "Energy Consumption Ratio",
  ENERGY_EFFICIENCY_CLASS: "EnA-Eff.kl",
  EPC_CONSUMPTION_KWH_M2A: "EPC-Consumption kWh/m²/a",
  FACADE_AREA: "Facade Area",
  FINANCIAL_DATA: "Financial Data",
  FLOOR_AMOUMT: "Floor amount",
  FOOTPRINT: "Footprint",
  FULL_ADDRESS: "Full Address",
  GLOBAL_SOLAR_PER_M2: "Global Solar (per m2)",
  GLOBAL_SOLAR_TOTAL: "Global Solar Total",
  GROSS_AREA_WITH_BASEMENT: "Gross area (incl. Basement)",
  GROSS_LETTABLE_AREA_WIGHOUT_BASEMENT: "Gross Lettable Area (without Basement)",
  // / 'Electricity Consumption EPC kWh/²/// 'Electricity Consumption EPC kWh/m,
  HEAT_ENERGY_CONSUMPTION_EPC_KWH_A: "Heat Energy Consumption kWh/a",
  HEAT_ENERGY_CONSUMPTION_EPC_KWH_M2_A: "Heat Energy Consumption EPC kWh/m²/a",
  HEAT_ENERGY_TYPE: "Heat Energy Type",
  HERITAGE_PROTECTED: "Heritage Protected",
  ID: "ID",
  IMAGE_URL_VALUE: "Imgae Url Value",
  INDEX: "index",
  LARGEST_ROOF_DIFFUSE_SOLAR_PER_M2: "Largest Roof Diffuse Solar (per m2)",
  LARGEST_ROOF_DIFFUSE_SOLAR_TOTAL: "Largest Roof Diffuse Solar Total",
  LARGEST_ROOF_DIRECT_SOLAR_PER_M2: "Largest Roof Direct Solar (per m2)",
  LARGEST_ROOF_DIRECT_SOLAR_TOTAL: "Largest Roof Direct Solar Total",
  LARGEST_ROOF_GLOBAL_SOLAR_PER_M2: "Largest Roof Global Solar (per m2)",
  LARGEST_ROOF_GLOBAL_SOLAR_TOTAL: "Largest Roof Global Solar Total",
  LATITUDE: "lat",
  LOGGIA: "Loggia",
  LONGITUDE: "lon",
  MAIN_DISTRICT: "Main District",
  NATURAL_GAS_AVAILABLE: "Natural Gas available",
  NET_AREA_WITH_BASEMENT: "Net Area (incl. Basement)",
  NET_LETTABEL_AREA_WITHOUT_BASEMENT: "Net Lettable Area (without Basement)",
  // 'Accounting Area': '',
  NONE: "",
  PORTFOLIO: "Portfolio",
  PRE_FABRICATED: "Pre Fabricated",
  PREMISE: "Premise",
  RENTAL_UNITS: "Rental Units",
  RETROFITS: "Retrofits",
  SOLD_ON: "Sold on",
  STRANDING_YEAR: "Stranding year",
  STREET: "Street",
  SUB_DISTRICT: "Sub District",
  TOTAL_ENERGY_CONSUMPTION: "Total Energy consumption",
  USE_TYPE: "Use type",
  YEAR_OF_CONSTRUCTION: "Year of construction",
  ZIP: "Zip",
  ...FinancialDataColsDisplayNamesEnums,
  ...RetrifitsColsDisplayNamesEnums,
  ...groupedColsDisplayNamesEnums,
  ...TechnicalDataColsDisplayNamesEnums,
});

export const columnsAPINamesEnums = Object.freeze({
  BALCONY: "balcony",
  BOUGHT_ON: "bought_on",
  BUILDING_ID: "asset_id",
  BUILDING_NAME: "descriptive_name",
  BUILDING_TYPE: "building_type",
  BUILDING_TYPE_ID: "building_type_id",
  CEILING_AREA: "ceiling_area",
  CITY: "city",
  CO2_EMISSION: "carbon_dioxide_emission_value",
  COUNT: "Count",
  DIFFUSE_SOLAR_PER_M2: "diffuse_solar_per_sq_meter_kwh",
  DIFFUSE_SOLAR_TOTAL: "diffuse_solar_total_kwh",
  DIRECT_SOLAR_PER_M2: "direct_solar_per_sq_meter_kwh",
  DIRECT_SOLAR_TOTAL: "direct_solar_total_kwh",
  DISTRICT_HEATING_AVAILABLE: "district_heating_available",
  ELECTRICITY_DEMAND_KWH_A: "electricity_demand_kwh_per_annum",
  ELECTRICITY_DEMAND_KWH_M2A: "electricity_demand_kwh_per_square_meter_annum",
  ENERGY_CONSUMPTION_RATIO: "consumption_vs_reference",
  ENERGY_EFFICIENCY_CLASS: "energy_label",
  EPC_CONSUMPTION_KWH_M2A: "epc_consumption_kwh_per_square_meter_annum",
  FACADE_AREA: "facade_area",
  FINANCIAL_DATA: "financialData", // Not in api with this name
  FLOOR_AMOUMT: "floor_amount",
  FOOTPRINT: "footprint_area",
  FULL_ADDRESS: "address",
  GLOBAL_SOLAR_PER_M2: "global_solar_per_sq_meter_kwh",
  GLOBAL_SOLAR_TOTAL: "global_solar_total_kwh",
  GROSS_AREA_WITH_BASEMENT: "gross_asset_basement_included",
  GROSS_LETTABLE_AREA_WIGHOUT_BASEMENT: "gross_lettable_area_without_basement",
  HEAT_ENERGY_CONSUMPTION_EPC_KWH_A: "heat_energy_consumption_kwh_per_annum",
  HEAT_ENERGY_CONSUMPTION_EPC_KWH_M2_A: "heat_energy_consumption_epc_kwh_per_square_meter_annum",
  HEAT_ENERGY_TYPE: "heat_energy_type",
  HERITAGE_PROTECTED: "heritage_protected",
  // 'Accounting Area': '',
  ID: "id",
  IMAGE_URL_VALUE: "image_url_value",
  LARGEST_ROOF_DIFFUSE_SOLAR_PER_M2: "largest_roof_diffuse_solar_per_sq_meter_kwh",
  LARGEST_ROOF_DIFFUSE_SOLAR_TOTAL: "largest_roof_diffuse_solar_total_kwh",
  LARGEST_ROOF_DIRECT_SOLAR_PER_M2: "largest_roof_direct_solar_per_sq_meter_kwh",
  LARGEST_ROOF_DIRECT_SOLAR_TOTAL: "largest_roof_direct_solar_total_kwh",
  LARGEST_ROOF_GLOBAL_SOLAR_PER_M2: "largest_roof_global_solar_per_sq_meter_kwh",
  LARGEST_ROOF_GLOBAL_SOLAR_TOTAL: "largest_roof_global_solar_total_kwh",
  LATITUDE: "latitude",
  LOGGIA: "loggia",
  LONGITUDE: "longitude",
  MAIN_DISTRICT: "main_district",
  NATURAL_GAS_AVAILABLE: "natural_gas_available",
  NET_AREA_WITH_BASEMENT: "net_area_basement_included",
  NET_LETTABEL_AREA_WITHOUT_BASEMENT: "net_lettable_area_without_basement",
  PORTFOLIO: "portfolio",
  PRE_FABRICATED: "pre_fabricated",
  PREMISE: "premise_area",
  RENTAL_UNITS: "rental_units",
  RETROFITS: "retrofits",
  SOLD_ON: "sold_on",
  STRANDING_YEAR: "stranding_year",
  STREET: "street",
  SUB_DISTRICT: "sub_district",
  TECHNICAL_DATA: "technical_data",
  TOTAL_ENERGY_CONSUMPTION: "energy_consumption",
  USE_TYPE: "type",
  YEAR_OF_CONSTRUCTION: "construction_year",
  ZIP: "post_code",
  ...FinancialDataColsNamesEnums,
  ...RetrifitsColsNamesEnums,
  ...groupedColsNamesEnums,
  ...TechnicalDataColsNamesEnums,
  // / 'Electricity Consumption EPC kWh/²/// 'Electricity Consumption EPC kWh/m,
});

export const dataMapping = Object.keys(columnsAPINamesEnums).reduce((acc, colEnum) => {
  acc[columnsAPINamesEnums[colEnum]] = columnsDisplayNamesEnums[colEnum];
  return acc;
}, {});

export const categoricalColumns = [
  // 'Accounting Area': ''
  // a': '':// 'Electricity Consumption EPC kWh/m,
  columnsAPINamesEnums.PORTFOLIO,
  columnsAPINamesEnums.BUILDING_NAME,
  columnsAPINamesEnums.ZIP,
  columnsAPINamesEnums.CITY,
  columnsAPINamesEnums.MAIN_DISTRICT,
  columnsAPINamesEnums.SUB_DISTRICT,
  columnsAPINamesEnums.FULL_ADDRESS,
  columnsAPINamesEnums.STREET,
  columnsAPINamesEnums.HERITAGE_PROTECTED,
  columnsAPINamesEnums.BUILDING_TYPE,
  columnsAPINamesEnums.PRE_FABRICATED,
  columnsAPINamesEnums.LOGGIA,
  columnsAPINamesEnums.BALCONY,
  columnsAPINamesEnums.USE_TYPE,
  columnsAPINamesEnums.ENERGY_EFFICIENCY_CLASS,
  columnsAPINamesEnums.HEAT_ENERGY_TYPE,
  columnsAPINamesEnums.IMAGE_URL_VALUE,

  columnsAPINamesEnums[getRetrofitPrefix("COMPONENT")],
  columnsAPINamesEnums[getRetrofitPrefix("LOAN_TYPE")],
  columnsAPINamesEnums[getRetrofitPrefix("MEASURE_DESCRIPTION")],
  columnsAPINamesEnums[getRetrofitPrefix("NAME")],
  columnsAPINamesEnums[getRetrofitPrefix("PDF_URL")],
  columnsAPINamesEnums[getRetrofitPrefix("SUB_COMPONENT")],
  columnsAPINamesEnums[getRetrofitPrefix("TYPE_OF_MESSURE")],

  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.WINDOW_TYPE)],
  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.COLOR)],
  columnsAPINamesEnums[getTechDataPrefix("Technical Data SUB_COMPONENT")],
  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.ENERGY_SOURCE)],
  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.MANUFACTURER_NAME)],
  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.MONITORING_INSTALLED)],
  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.SYSTEM_NAME)],
  columnsAPINamesEnums[getTechDataPrefix(techDataColsAPINames.SYSTEM_TYPE)],

  columnsAPINamesEnums.GROUPED__FINANCIAL_DATA__ALL,
];

export const portfolioScaleableColumns = [
  // columnsAPINamesEnums.CEILING_AREA,
  columnsAPINamesEnums.CO2_EMISSION,
  columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_A,
  columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_M2A,
  columnsAPINamesEnums.EPC_CONSUMPTION_KWH_M2A,
  // columnsAPINamesEnums.FACADE_AREA,
  // columnsAPINamesEnums.RENTAL_UNITS,
  // columnsAPINamesEnums.FLOOR_AMOUMT,
  // columnsAPINamesEnums.FOOTPRINT,
  // columnsAPINamesEnums.GROSS_AREA_WITH_BASEMENT,
  // columnsAPINamesEnums.GROSS_LETTABLE_AREA_WIGHOUT_BASEMENT,
  columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_A,
  columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_M2_A,
  // columnsAPINamesEnums.NET_AREA_WITH_BASEMENT,
  // columnsAPINamesEnums.NET_LETTABEL_AREA_WITHOUT_BASEMENT,
  // columnsAPINamesEnums.PREMISE,
  columnsAPINamesEnums.TOTAL_ENERGY_CONSUMPTION,

  FinancialDataColsNamesEnums.FINANCIAL_DATA__CASH_FLOW,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__ENERGY_SAVINGS,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__FOREIGN_CAPITAL,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__FOREIGN_CAPITAL_COST,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__LOAN_REPAYMENT,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__MAINTENANCE_COST,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__OTHER_SAVINGS,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__OWN_CAPITAL,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__SERVICES_COSTS,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__SUBSIDIES,
  FinancialDataColsNamesEnums.FINANCIAL_DATA__TOTALS__ALL,

  ...retrofitsScaleableColumns.map((col) => getRetrofitPrefix(col)),
];

export const parentDataGroupedColumns = {
  //  Can be added when needed like this:
  // [columnsAPINamesEnums.GROUPED__CONSUMPTION]: {
  //   aggregatedColumn: columnsAPINamesEnums.TOTALS__CONSUMPTION,
  //   columns: [
  //     columnsAPINamesEnums.TOTAL_ENERGY_CONSUMPTION,
  //     columnsAPINamesEnums.CO2_EMISSION,
  //     columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_M2_A,
  //     columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_M2A,
  //   ],
  // },
};

export const retrofitsGroupedColumns = {
  //  Can be added when needed like this:
  // [columnsAPINamesEnums.GROUPED__RETROFITS__REDUCTIONS]: {
  //   aggregatedColumn: columnsAPINamesEnums.RETROFITS__TOTALS__REDUCTIONS,
  //   columns: [
  //     columnsAPINamesEnums.RETROFITS__REDUCTION_ELECTRICITY_PRIMARY,
  //     columnsAPINamesEnums.RETROFITS__REDUCTION_ENERGY_DEMAND,
  //     columnsAPINamesEnums.RETROFITS__REDUCTION_ENERGY_END,
  //     columnsAPINamesEnums.RETROFITS__REDUCTION_ENERGY_PRIMARY,
  //     columnsAPINamesEnums.RETROFITS__REDUCTION_HEAT_END,
  //     columnsAPINamesEnums.RETROFITS__REDUCTION_HEAT_PRIMARY,
  //   ],
  // },
};

export const financialDataGroupedColumns = {
  [columnsAPINamesEnums.GROUPED__FINANCIAL_DATA__ALL]: {
    aggregatedColumn: columnsAPINamesEnums.FINANCIAL_DATA__TOTALS__ALL,
    columns: Object.values(FinancialDataColsNamesEnums).filter(
      (colName) =>
        colName !== FinancialDataColsNamesEnums.FINANCIAL_DATA__YEAR &&
        colName !== FinancialDataColsNamesEnums.FINANCIAL_DATA__TOTALS__ALL
    ),
  },
};

export const allDataGroupedColumns = {
  ...parentDataGroupedColumns,
  ...retrofitsGroupedColumns,
  ...financialDataGroupedColumns,
};

export const allGroupsNames = Object.keys(allDataGroupedColumns);

export const dataNeededColumns = Object.values(columnsAPINamesEnums).filter(
  (col) => col !== columnsAPINamesEnums.IMAGE_URL_VALUE
);
export const infoBoxAndTableNeededColumns = [
  // Info Box Specific
  columnsAPINamesEnums.ID,
  columnsAPINamesEnums.FULL_ADDRESS,
  columnsAPINamesEnums.GROSS_AREA_WITH_BASEMENT,
  columnsAPINamesEnums.YEAR_OF_CONSTRUCTION,
  columnsAPINamesEnums.STRANDING_YEAR,
  columnsAPINamesEnums.ENERGY_EFFICIENCY_CLASS,

  // Table Specific
  columnsAPINamesEnums.PORTFOLIO,
  columnsAPINamesEnums.HEAT_ENERGY_TYPE,

  // Common Columns
  columnsAPINamesEnums.USE_TYPE,
  columnsAPINamesEnums.IMAGE_URL_VALUE,
  columnsAPINamesEnums.BUILDING_NAME,
  columnsAPINamesEnums.CO2_EMISSION,
  columnsAPINamesEnums.TOTAL_ENERGY_CONSUMPTION,
  columnsAPINamesEnums.LATITUDE,
  columnsAPINamesEnums.LONGITUDE,
];

export const columnsUnits = Object.freeze({
  [columnsAPINamesEnums.BALCONY]: "",
  [columnsAPINamesEnums.BOUGHT_ON]: "Year",
  [columnsAPINamesEnums.BUILDING_ID]: "",
  [columnsAPINamesEnums.BUILDING_NAME]: "",
  [columnsAPINamesEnums.BUILDING_TYPE]: "",
  [columnsAPINamesEnums.BUILDING_TYPE_ID]: "",
  [columnsAPINamesEnums.CEILING_AREA]: "m²",
  [columnsAPINamesEnums.CITY]: "",
  [columnsAPINamesEnums.CO2_EMISSION]: "kg/m²/a",
  [columnsAPINamesEnums.COUNT]: "#",
  [columnsAPINamesEnums.DIFFUSE_SOLAR_PER_M2]: "kWh/m²/a",
  [columnsAPINamesEnums.DIFFUSE_SOLAR_TOTAL]: "kWh/a",
  [columnsAPINamesEnums.DIRECT_SOLAR_PER_M2]: "kWh/m²/a",
  [columnsAPINamesEnums.DIRECT_SOLAR_TOTAL]: "kWh/a",
  [columnsAPINamesEnums.DISTRICT_HEATING_AVAILABLE]: "",
  [columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_A]: "kWh/a",
  [columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_M2A]: "kWh/m²/a",
  [columnsAPINamesEnums.ENERGY_CONSUMPTION_RATIO]: "",
  [columnsAPINamesEnums.ENERGY_EFFICIENCY_CLASS]: "",
  [columnsAPINamesEnums.EPC_CONSUMPTION_KWH_M2A]: "kWh/m²/a",
  [columnsAPINamesEnums.FACADE_AREA]: "m²",
  [columnsAPINamesEnums.FLOOR_AMOUMT]: "",
  [columnsAPINamesEnums.FOOTPRINT]: "m²",
  [columnsAPINamesEnums.FULL_ADDRESS]: "",
  [columnsAPINamesEnums.GLOBAL_SOLAR_PER_M2]: "kWh/m²/a",
  [columnsAPINamesEnums.GLOBAL_SOLAR_TOTAL]: "kWh/a",
  [columnsAPINamesEnums.GROSS_AREA_WITH_BASEMENT]: "m²",
  [columnsAPINamesEnums.GROSS_LETTABLE_AREA_WIGHOUT_BASEMENT]: "m²",
  // [columnsNamesEnums.//] / 'Electricity Consumption EPC kWh/²/// 'Electricity Consumption EPC kWh/m,
  [columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_A]: "kWh/a",
  [columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_M2_A]: "kWh/m²/a",
  [columnsAPINamesEnums.HEAT_ENERGY_TYPE]: "",
  [columnsAPINamesEnums.HERITAGE_PROTECTED]: "",
  [columnsAPINamesEnums.LARGEST_ROOF_DIFFUSE_SOLAR_PER_M2]: "kWh/m²/a",
  [columnsAPINamesEnums.LARGEST_ROOF_DIFFUSE_SOLAR_TOTAL]: "kWh/a",
  [columnsAPINamesEnums.LARGEST_ROOF_DIRECT_SOLAR_PER_M2]: "kWh/m²/a",
  [columnsAPINamesEnums.LARGEST_ROOF_DIRECT_SOLAR_TOTAL]: "kWh/a",
  [columnsAPINamesEnums.LARGEST_ROOF_GLOBAL_SOLAR_PER_M2]: "kWh/m²/a",
  [columnsAPINamesEnums.LARGEST_ROOF_GLOBAL_SOLAR_TOTAL]: "kWh/a",
  [columnsAPINamesEnums.LATITUDE]: "Deg",
  [columnsAPINamesEnums.LOGGIA]: "",
  [columnsAPINamesEnums.LONGITUDE]: "Deg",
  [columnsAPINamesEnums.MAIN_DISTRICT]: "",
  [columnsAPINamesEnums.NATURAL_GAS_AVAILABLE]: "",
  [columnsAPINamesEnums.NET_AREA_WITH_BASEMENT]: "m²",
  [columnsAPINamesEnums.NET_LETTABEL_AREA_WITHOUT_BASEMENT]: "m²",
  // 'Accounting Area': '',
  [columnsAPINamesEnums.PORTFOLIO]: "",
  [columnsAPINamesEnums.PRE_FABRICATED]: "",
  [columnsAPINamesEnums.PREMISE]: "m²",
  [columnsAPINamesEnums.RENTAL_UNITS]: "",
  [columnsAPINamesEnums.SOLD_ON]: "Year",
  [columnsAPINamesEnums.STRANDING_YEAR]: "Year",
  [columnsAPINamesEnums.STREET]: "",
  [columnsAPINamesEnums.SUB_DISTRICT]: "",

  [columnsAPINamesEnums.TECHNICAL_DATA__AREA]: "m²",
  [columnsAPINamesEnums.TECHNICAL_DATA__AREA_COVERED]: "m²",
  [columnsAPINamesEnums.TECHNICAL_DATA__CAPACITY_PANEL]: "kWPeak",
  [columnsAPINamesEnums.TECHNICAL_DATA__COLOR]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__COP]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__DC_AC_INVERTER_CONFIGURATION]: "kWPeak",
  [columnsAPINamesEnums.TECHNICAL_DATA__DESCRIPTION]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__DISTRIBUTION_LOSSES]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__ENERGY_SOURCE]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__G_VALUE]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__INFILTRATION]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__INSTALLED]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__LAST_CHECKED]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__MANUFACTURER_NAME]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__MODERNIZATION]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__MONITORING_INSTALLED]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__PEAK_THERMAL_POWER]: "kW",
  [columnsAPINamesEnums.TECHNICAL_DATA__STORAGE_LOSSES]: "W",
  [columnsAPINamesEnums.TECHNICAL_DATA__STORAGE_TEMPERATURE]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__STORAGE_VOLUME]: "m³",
  [columnsAPINamesEnums.TECHNICAL_DATA__SUB_COMPONENT]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__SYSTEM_NAME]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__SYSTEM_TYPE]: "",
  [columnsAPINamesEnums.TECHNICAL_DATA__THICKNESS]: "m",
  [columnsAPINamesEnums.TECHNICAL_DATA__U_VALUE]: "W/m²K",
  [columnsAPINamesEnums.TECHNICAL_DATA__WINDOW_TYPE]: "",

  [columnsAPINamesEnums.TOTAL_ENERGY_CONSUMPTION]: "kWh/m²/a",
  [columnsAPINamesEnums.USE_TYPE]: "",
  [columnsAPINamesEnums.YEAR_OF_CONSTRUCTION]: "Year",
  [columnsAPINamesEnums.ZIP]: "",
});

export const getDefaultColors = () =>
  Object.freeze({
    [colorCategoriesEnums.COLUMNS]: {},
    [colorCategoriesEnums.VALUES]: {
      [columnsAPINamesEnums.ENERGY_EFFICIENCY_CLASS]: {
        ...Object.fromEntries(
          energyEfficiencyClassConf.map((energyClass) => [energyClass.rating, resolveCssVar(energyClass.bgColor)])
        ),
      },
    },
  });

const relevantConfigOptions = dynamicDashboardRelevantConfigOptions;

export const numbersScalesTypes = Object.freeze({
  BUILDING_AREA: "Building area",
  NO_SCALE: "No scale",
  TOTAL_AREA: "Total area",
});

export const isRelevantOption = (chartType, option, index) => {
  if (
    index > 0 &&
    chartType !== chartTypesEnums.HISTOGRAM &&
    chartType !== chartTypesEnums.COMPOSED &&
    chartType !== chartTypesEnums.SCATTER
  )
    return false;
  return relevantConfigOptions[chartType]?.includes(option);
};

export const PORTFOLIO_NAME_IN_API_BODY = "portfolio";
export const APP_NAME_IN_REDUX = "portfolio";

export const dropdownFilters = [
  columnsAPINamesEnums.PORTFOLIO,
  columnsAPINamesEnums.USE_TYPE,
  columnsAPINamesEnums.ENERGY_EFFICIENCY_CLASS,
  columnsAPINamesEnums.BUILDING_TYPE_ID,
  columnsAPINamesEnums.BUILDING_TYPE,
  columnsAPINamesEnums.PRE_FABRICATED,
  columnsAPINamesEnums.BUILDING_ID,
  columnsAPINamesEnums.BUILDING_NAME,
  columnsAPINamesEnums.HEAT_ENERGY_TYPE,
  columnsAPINamesEnums.ZIP,
  columnsAPINamesEnums.CITY,
  columnsAPINamesEnums.MAIN_DISTRICT,
  columnsAPINamesEnums.SUB_DISTRICT,
  columnsAPINamesEnums.FULL_ADDRESS,
  columnsAPINamesEnums.STREET,
  columnsAPINamesEnums.HERITAGE_PROTECTED,
  columnsAPINamesEnums.DISTRICT_HEATING_AVAILABLE,
  columnsAPINamesEnums.NATURAL_GAS_AVAILABLE,
  columnsAPINamesEnums.LOGGIA,
  columnsAPINamesEnums.BALCONY,
];

export const numericRangeFilters = [
  columnsAPINamesEnums.PREMISE,
  columnsAPINamesEnums.FOOTPRINT,
  columnsAPINamesEnums.GROSS_AREA_WITH_BASEMENT,
  columnsAPINamesEnums.GROSS_LETTABLE_AREA_WIGHOUT_BASEMENT,
  columnsAPINamesEnums.FLOOR_AMOUMT,
  columnsAPINamesEnums.ENERGY_CONSUMPTION_RATIO,
  columnsAPINamesEnums.YEAR_OF_CONSTRUCTION,
  columnsAPINamesEnums.STRANDING_YEAR,
  columnsAPINamesEnums.TOTAL_ENERGY_CONSUMPTION,
  columnsAPINamesEnums.CO2_EMISSION,
  columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_A,
  columnsAPINamesEnums.HEAT_ENERGY_CONSUMPTION_EPC_KWH_M2_A,
  columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_A,
  columnsAPINamesEnums.ELECTRICITY_DEMAND_KWH_M2A,
  columnsAPINamesEnums.CEILING_AREA,
  columnsAPINamesEnums.FACADE_AREA,
  columnsAPINamesEnums.NET_AREA_WITH_BASEMENT,
  columnsAPINamesEnums.NET_LETTABEL_AREA_WITHOUT_BASEMENT,
  columnsAPINamesEnums.EPC_CONSUMPTION_KWH_M2A,
  columnsAPINamesEnums.BOUGHT_ON,
  columnsAPINamesEnums.SOLD_ON,
  columnsAPINamesEnums.RENTAL_UNITS,
  columnsAPINamesEnums.DIFFUSE_SOLAR_PER_M2,
  columnsAPINamesEnums.DIFFUSE_SOLAR_TOTAL,
  columnsAPINamesEnums.DIRECT_SOLAR_PER_M2,
  columnsAPINamesEnums.DIRECT_SOLAR_TOTAL,
  columnsAPINamesEnums.GLOBAL_SOLAR_PER_M2,
  columnsAPINamesEnums.GLOBAL_SOLAR_TOTAL,
  columnsAPINamesEnums.LARGEST_ROOF_DIFFUSE_SOLAR_PER_M2,
  columnsAPINamesEnums.LARGEST_ROOF_DIFFUSE_SOLAR_TOTAL,
  columnsAPINamesEnums.LARGEST_ROOF_DIRECT_SOLAR_PER_M2,
  columnsAPINamesEnums.LARGEST_ROOF_DIRECT_SOLAR_TOTAL,
  columnsAPINamesEnums.LARGEST_ROOF_GLOBAL_SOLAR_PER_M2,
  columnsAPINamesEnums.LARGEST_ROOF_GLOBAL_SOLAR_TOTAL,
];
